<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="8"
        >
          <b-form-group
            label="Başlık"
            label-for="title"
          >
            <b-form-input
              id="title"
              v-model="itemData.title"
              placeholder="Başlık"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Menü Tipi"
            label-for="id_menu_types"
          >
            <v-select
              id="id_menu_types"
              v-model="itemData.id_menu_types"
              :options="menu_types"
              label="title"
              :reduce="item => item.id"
              placeholder="Menü Tipi"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="8"
        >
          <b-form-group
            label="Bağlantı"
            label-for="route"
            description="Site sayfa anahtarı (urunlerimiz, uretim#3, page:hakkimizda...) veya https:// ile başlayan dış bağlantı. Boş bırakılırsa yalnızca alt menü başlığı olur."
          >
            <b-form-input
              id="route"
              v-model="itemData.route"
              list="menu-route-links"
              placeholder="page:hakkimizda"
            />
            <datalist id="menu-route-links">
              <option
                v-for="option in linkOptions"
                :key="option"
                :value="option"
              />
            </datalist>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Otomatik Alt Menü"
            label-for="dynamic"
          >
            <v-select
              id="dynamic"
              v-model="itemData.dynamic"
              :options="dynamicTypes"
              label="title"
              :reduce="item => item.value"
              placeholder="Yok"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Sıra No"
            label-for="ordering"
          >
            <b-form-input
              id="ordering"
              v-model="itemData.ordering"
              type="number"
              placeholder="Sıra No"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Bağlantı Tipi"
            label-for="target"
          >
            <v-select
              id="target"
              v-model="itemData.target"
              placeholder="Bağlantı"
              :options="targetTypes"
              label="title"
              :reduce="item => item.value"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Durum"
            label-for="status"
          >
            <v-select
              id="status"
              v-model="itemData.status"
              placeholder="Durum"
              :options="statues"
              label="title"
              :reduce="item => item.value"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Üst Menü Öğesi"
            label-for="id_menus"
          >
            <v-select
              id="id_menus"
              v-model="itemData.id_menus"
              placeholder="Ana Menü"
              :options="parentMenus"
              label="title"
              :reduce="item => item.id"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-button
      variant="primary"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>
<script>
import {
  BButton, BCard, BCol, BFormGroup, BFormInput, BRow,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import siteLinks from '@/views/Admin/siteLinks'

export default {
  name: 'MenuForm',
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    vSelect,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      linkOptions: siteLinks,
      dynamicTypes: [
        {
          title: 'Üretim adımları',
          value: 'production',
        },
        {
          title: 'Ürün grupları',
          value: 'products',
        },
      ],
      targetTypes: [
        {
          title: 'Aynı Pencerede',
          value: '_self',
        },
        {
          title: 'Yeni Sekmede',
          value: '_blank',
        },
      ],
      statues: [
        {
          title: 'Aktif',
          value: '1',
        },
        {
          title: 'Pasif',
          value: '0',
        },
      ],
    }
  },
  computed: {
    menu_types() {
      return this.$store.getters['menuTypes/dataList']
    },
    parentMenus() {
      return this.$store.getters['menus/dataList']
    },
    itemData() {
      return this.$store.getters['menus/dataItem']
    },
  },
  created() {
    this.getParentMenus()
    this.getMenuTypes()
  },
  methods: {
    getParentMenus() {
      this.$store.dispatch('menus/getDataList')
    },
    getMenuTypes() {
      this.$store.dispatch('menuTypes/getDataList', {
        select: [
          'menu_types.id AS id',
          'menu_types.title AS title',
        ],
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
